import fetch from '@/utils/fetch';
import axios from "axios";

// 用户信息
export function getInfo() {
    return fetch({
        url: '/client/getUserInfo',
        method: 'get',
    })
}
//获取余额
export function getCustomerBalance() {
    return fetch({
        url: '/client/customerBalance',
        method: 'get',
    })
}
//余额设置
export function setCustomerBalance(data) {
    return fetch({
        url: '/client/setCustomerBalance',
        method: 'post',
        data
    })
}
//忘记密码
export function forgetPassword(data) {
    return fetch({
        url: '/client/changePassword',
        method: 'post',
        data
    })
}
//获取验证码
export function getValidateCode(params) {
    return fetch({
        url: '/client/getValidateCode',
        method: 'get',
        params
    })
}
//用户是否查看协议
export function getReadProtal(params) {
    return fetch({
        url: '/client/myReadProtal',
        method: 'get',
        params
    })
}
// 确认协议
export function sureProtal(data) {
    return fetch({
        url: '/client/readProtal',
        method: 'post',
        data
    })
}
//账户注册
export function registerAccount(data) {
    return fetch({
        url: '/client/customer/register',
        method: 'post',
        data
    })
}
//获取验证码
export function geRegisterValidateCode(email) {
    return fetch({
        url: '/client/get/verificationCode?email=' + email,
        method: 'get',
    })
}

// 根据客户id搜索未核销充值单
export function getRechargeOrderByCustomerId(params) {
    return fetch({
        url: '/client/payment/pa/glocalpay/recharge/record',
        method: 'post',
        params
    })
}

// 获取验证码图片
export function getCaptchaImage() {
    return axios({
        url: '/client/captchaImage',
        method: 'get',
        headers: { isToken: false }
    }).then(res => res.data)
}

// 生成安全链接发送更换邮箱地址
export function genSecureLink(data) {
    return fetch({
        url: '/client/account/genSecureLink',
        method: 'post',
        data
    })
}

// 校验更换邮箱安全链接
export function verifyLink(params) {
    return axios({
        url: '/client/account/verifyLink',
        method: 'get',
        params,
        headers: { isToken: false }
    }).then(res => res.data)
}

// 确认更换邮箱
export function confirmChangeEmail(params) {
    return fetch({
        url: '/client/account/confirmChangeEmail',
        method: 'post',
        params,
        headers: { isToken: false, ignore401: true }
    })
}


// 账号列表分页查询
export function getAccountList(data) {
    return fetch({
        url: '/client/account/list',
        method: 'post',
        data
    })
}

// 新增账号
export function addAccount(data) {
    return fetch({
        url: '/client/account/add',
        method: 'post',
        data
    })
}

// 更新账号状态
export function updateAccountStatus(data) {
    return fetch({
        url: '/client/account/updateStatus',
        method: 'post',
        data
    })
}

export function updatePassword(params) {
    return fetch({
        url: '/client/account/updatePassword',
        method: 'post',
        params
    })
}

export function initAccountPassword(params) {
    return fetch({
        url: '/client/customer/getInitPassword',
        method: 'get',
        params
    })
}

export function sendInitAccountPassword(params) {
    return fetch({
        url: '/client/customer/sendInitPassword',
        method: 'get',
        params
    })
}

// 删除账号
export function deleteAccount(data) {
    return fetch({
        url: '/client/account/delete',
        method: 'post',
        data
    })
}

export function getCustomerList(data) {
    return fetch({
        url: '/client/customer/list',
        method: 'post',
        data
    })
}

export function getListByCidOrName(params) {
    return fetch({
        url: '/client/customer/getListByCidOrName',
        method: 'get',
        params
    })
}

export function getCustomerListByGroupId(params) {
    return fetch({
        url: '/client/customer/getByGroupId',
        method: 'get',
        params
    })
}

export function updateCustomerStatus(data) {
    return fetch({
        url: '/client/customer/updateStatus',
        method: 'post',
        data
    })
}

export function addCustomer(data) {
    return fetch({
        url: '/client/customer/add',
        method: 'post',
        data
    })
}

export function editCustomer(data) {
    return fetch({
        url: '/client/customer/edit',
        method: 'post',
        data
    })
}

export function getDicts(dictType) {
    return fetch({
        url: '/system/dict/data/dictType/' + dictType,
        method: 'get'
    })
}

export function getCustomerQuotationList(data) {
    return fetch({
        url: '/client/skuCustomerOfferAgent/pageList',
        method: 'post',
        data
    })
}

export function exportCustomerQuotationTemplate(data) {
    return fetch({
        url: '/client/sku/export',
        method: 'post',
        data,
        responseType: 'blob'
    })
}

export function getCustomerQuotationDetail(data) {
    return fetch({
        url: '/client/skuCustomerOfferAgent/pageListOperator',
        method: 'post',
        data
    })
}

export function getCustomerQuotationHistory(data) {
    return fetch({
        url: '/client/skuCustomerOfferAgent/selectHistory',
        method: 'post',
        data
    })
}

export function uploadCustomerQuotation(data) {
    return fetch({
        url: '/client/skuCustomerOfferAgent/upload',
        method: 'post',
        data
    })
}

export function addCustomerQuotationPrice(data) {
    return fetch({
        url: '/client/skuCustomerOfferAgent/addMultipleOperatorPrice',
        method: 'post',
        data
    })
}

export function getPlatformCustomerQuotationList(data) {
    return fetch({
        url: '/client/skuCustomerOffer/pageList',
        method: 'post',
        data
    })
}


export function getPlatformCustomerQuotationDetail(data) {
    return fetch({
        url: '/client/skuCustomerOffer/pageListOperator',
        method: 'post',
        data
    })
}

export function getPlatformCustomerQuotationHistory(data) {
    return fetch({
        url: '/client/skuCustomerOffer/selectHistory',
        method: 'post',
        data
    })
}

export function getCustomerApplicationList(data) {
    return fetch({
        url: '/client/customer/app/list',
        method: 'post',
        data
    })
}

export function getListByAppIdOrName(params) {
    return fetch({
        url: '/client/customer/app/getListByAppIdOrName',
        method: 'get',
        params
    })
}

export function addCustomerApplication(data) {
    return fetch({
        url: '/client/customer/app/add',
        method: 'post',
        data
    })
}

export function editCustomerApplication(data) {
    return fetch({
        url: '/client/customer/app/edit',
        method: 'post',
        data
    })
}

export function updateCustomerApplicationStatus(data) {
    return fetch({
        url: '/client/customer/app/updateStatus',
        method: 'post',
        data
    })
}

export function deleteCustomerApplication(data) {
    return fetch({
        url: '/client/customer/app/del',
        method: 'post',
        data
    })
}

export function getCustomerAccountInfo(params) {
    return fetch({
        url: '/client/customer/app/account/get',
        method: 'get',
        params
    })
}

export function credit(data) {
    return fetch({
        url: '/client/customer/credit',
        method: 'post',
        data
    })
}
